export enum View {
  HOME = 'home',
  ADD_USERS = 'add',
  DELETE_USERS = 'delete',
  EDIT_USERS = 'edit'
}
